import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  gap: 20px;

  > * {
    width: 100%;
  }

  .pay-button {
    font-size: 20px;
    line-height: 24px;
  }
`;
